import AdminListPage from "./components/AdminListPage";
export default function KategoriKutipanList() { return <AdminListPage title="Senarai Kategori Kutipan" endpoint="/admin/kategori_kutipan" />; }
